import {
    AnticsContext,
    AnticsFeatures,
} from './types'

export const antics = () => {
    const newClientInstance = (hostUrl: string, xUserAgent: string, features?: AnticsFeatures) => {
        const maxContentLength = 1024 * 1024
        const maxDelayIncrement = 5000 // ms
        const maxDelayFactor = 32

        const buf = new ArrayBuffer(8) // 64 bits
        window.crypto.getRandomValues(new Uint8Array(buf, 1)) // 56 random bits
        const view = new DataView(buf)
        // eslint-disable-next-line no-extra-parens, no-bitwise
        const clientInstance = (view.getUint32(0) * (1 << 32)) + view.getUint32(4) // 56-bit number

        let contentEpilogue = ']'

        let contentPrologue = '['
        let sessionIndex = 0
        if (features) {
            contentPrologue = `{"f":${JSON.stringify(features)},"*":[`
            contentEpilogue = ']}'
        }

        return {
            clientInstance,

            newSessionContext() {
                const clientSessionUrl = `${hostUrl}/${clientInstance}/${sessionIndex}`
                let sendId: number | null = null
                let sending = false
                let delayFactor = 1
                let buffer: Array<string> = []
                let bufferSize = 0

                const doSend = () => {
                    sendId = null
                    sending = true

                    const xhr = new XMLHttpRequest()
                    xhr.open('POST', clientSessionUrl, true)
                    xhr.setRequestHeader('Content-Type', 'application/json')
                    xhr.setRequestHeader('X-User-Agent', xUserAgent)
                    xhr.send(contentPrologue + buffer.join(',') + contentEpilogue)

                    const sendCount = buffer.length

                    xhr.onload = () => {
                        delayFactor = 1
                        buffer = buffer.slice(sendCount)
                        bufferSize = 0
                        // eslint-disable-next-line guard-for-in
                        for (const i in buffer) {
                            bufferSize += 1 + buffer[i].length
                        }
                    }

                    xhr.onerror = () => {
                        delayFactor *= 2
                        if (delayFactor > maxDelayFactor) {
                            delayFactor = maxDelayFactor
                        }
                    }

                    xhr.onloadend = () => {
                        sending = false
                        if (buffer.length > 0) {
                            sendId = window.setTimeout(doSend, Math.random() * delayFactor * maxDelayIncrement)
                        }
                    }
                }

                const context: AnticsContext = {

                    flush() {
                        if (buffer.length > 0 && !sending) {
                            if (sendId) {
                                clearTimeout(sendId)
                                sendId = null
                            }

                            doSend()
                        }
                    },

                    send(entry: Record<string, unknown>) {
                        entry['@'] = Math.floor(new Date().getTime() / 1000)

                        const jsonEntry = JSON.stringify(entry)
                        const newSize = bufferSize + 1 + jsonEntry.length

                        if (newSize + 1 <= maxContentLength) {
                            buffer.push(jsonEntry)
                            bufferSize = newSize

                            if (!sendId && !sending) {
                                sendId = window.setTimeout(doSend, Math.random() * maxDelayIncrement)
                            }
                        }
                    },

                    sessionIndex,

                }

                sessionIndex += 1

                return context
            },
        }
    }

    return {newClientInstance}
}
